import {
  createProviderProduct,
  updateProviderProduct,
  deleteProviderProduct,
} from "@/api/providerDashboard";

export default {
  async handleSubmit() {
    if (!this.form.name) {
      return this.$message.warning("상품 이름을 입력해주세요.");
    }
    if (this.form.imagesUrls.length === 0) {
      return this.$message.warning("이미지를 최소 1장 업로드해주세요.");
    }

    this.submitting = true;
    try {
      if (this.isEdit) {
        await updateProviderProduct(this.$route.params.id, this.form);
        this.$message.success("상품이 수정되었습니다.");
      } else {
        await createProviderProduct(this.form);
        this.$message.success("상품이 등록되었습니다.");
      }
      this.$router.push("/products");
    } catch (err) {
      this.$message.error("저장에 실패했습니다.");
    } finally {
      this.submitting = false;
    }
  },
  async handleDelete() {
    try {
      await this.$confirm("상품을 삭제하시겠습니까?", "삭제 확인", {
        confirmButtonText: "삭제",
        cancelButtonText: "취소",
        type: "warning",
      });

      await deleteProviderProduct(this.$route.params.id);
      this.$message.success("상품이 삭제되었습니다.");
      this.$router.push("/products");
    } catch (err) {
      if (err !== "cancel") {
        this.$message.error("삭제에 실패했습니다.");
      }
    }
  },
};
